<div class="shadow-box max-w-screen-md flex flex-col items-center min-h-96 relative">
    <div class="flex flex-row absolute top-2 right-2 p-2">
        @if(showFlag){
            <div id="flag" class="has-tooltip pr-2" (click)="toggleFlagged()">
                @if(flagged){
                    <span class="tooltip -mt-10 p-1 w-max rounded bg-blue text-white">Markierung entfernen</span>
                <ng-icon class="text-blue" size="25" name="faSolidBookmark"></ng-icon>
                } @else {
                    <span class="tooltip -mt-10 p-1 w-max rounded bg-blue text-white">Markieren</span>
        
                <ng-icon class="text-blue" size="25" name="faBookmark"></ng-icon>
                }
            </div>
            }
            <app-action-dropdown [question]="question" [orderSeed]="orderSeed" />
    </div>

    @if(index && total){
    <span class="font-semibold">{{ index }} von {{ total }}</span>
    } @else if (index){
    <span class="font-semibold">Frage {{ index }}</span>
    }
    @if(question){
        <p class="question py-4 px-6">{{ question.value }}</p>
    }
    <fieldset class="block w-full mt-2 px-6">
        @if(question?.show_expected) {
        @if(correctCount === 1){
        <p class="italic">Choose the best answer.</p>
        } @else {
        <p class="italic">Choose the best {{correctCount}} answers.</p>
        }
        } @else {
            <p class="italic">Choose all that apply.</p>
        }
        @for(answerOption of question?.expand?.answer_options; track answerOption.id; let i = $index){
        <div>
            <label class="inline-flex items-center my-4 answer-text cursor-pointer">
                @if(question?.show_expected && correctCount === 1){
                <input class="form-radio h-6 w-6" type="radio" name="singleSelectAnswer" [disabled]="disabled"
                    [value]="answerOption.id" [id]="answerOption.id" (change)="onSelectionChange()" />
                <span class="ml-2">{{ i + 1 }}. {{ answerOption.value }}</span>
                } @else {
                <input class="form-checkbox rounded-md h-6 w-6" type="checkbox" name="answer_option" [disabled]="disabled"
                    [value]="answerOption.id" [id]="answerOption.id" (change)="onSelectionChange()" />
                <span class="ml-2">{{ i + 1 }}. {{ answerOption.value }}</span>
                }
            </label>
        </div>
        }
    </fieldset>
</div>